import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4d230bd8")

_pushScopeId("data-v-4d230bd8")
const _hoisted_1 = { class: "poster-img" }
const _hoisted_2 = {
  key: 0,
  class: "banner"
}
const _hoisted_3 = { class: "duration" }
const _hoisted_4 = /*#__PURE__*/_createVNode("svg", {
  width: "7",
  height: "7",
  viewBox: "0 0 13 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M0.845047 2.67638C0.845047 1.1242 2.53628 0.16363 3.86942 0.958634L11.1197 5.28229C12.4205 6.05803 12.4205 7.94203 11.1197 8.71778L3.86943 13.0415C2.53629 13.8365 0.845043 12.876 0.845044 11.3238L0.845047 2.67638Z",
    class: "pw-play-btn"
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: `option-holder ${_ctx.isSelected ? 'selected' : ''}`,
    "aria-label": `${_ctx.translateLabels('Play')}-${_ctx.title ?? _ctx.description ?? 'video'}`
  }, [
    _createVNode("div", _hoisted_1, [
      (_ctx.isWebinar)
        ? (_openBlock(), _createBlock("div", _hoisted_2, "Full video"))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createTextVNode(_toDisplayString(_ctx.duration), 1)
      ]),
      _createVNode("img", {
        draggable: "false",
        src: _ctx.poster_url
      }, null, 8, ["src"])
    ]),
    (_ctx.title)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "title",
          innerHTML: _ctx.stripHtmlTags(_ctx.title)
        }, null, 8, ["innerHTML"]))
      : _createCommentVNode("", true),
    (_ctx.description)
      ? (_openBlock(), _createBlock("div", {
          key: 1,
          class: `description ${_ctx.title ? '' : 'big'}`,
          innerHTML: _ctx.stripHtmlTags(_ctx.description)
        }, null, 10, ["innerHTML"]))
      : _createCommentVNode("", true)
  ], 10, ["aria-label"]))
})